import { SvelteComponent, init, safe_not_equal, element, text, attr, insert, append, set_data, detach, space, create_component, src_url_equal, toggle_class, mount_component, listen, transition_in, transition_out, create_out_transition, destroy_component, createEventDispatcher, onMount, noop } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import { fade } from '../../../../external_node_modules/svelte/transition/index.mjs.js';
import { updateBrowserControlState } from '../../../../external_node_modules/@wg/web2clientapi/browser/updateBrowserControlState.js';
import { isIngame } from '../../../../external_node_modules/@wg/web2clientapi/utils/checkIngame.js';
import { playExchangeSound } from '../../../../external_node_modules/@wg/web2clientapi/sound/index.js';
import { t } from '../../../../i18n.js';
import { disableBodyOverflow } from '../../../../utils/disableBodyOverflow.js';
import Button from '../Button/Button.svelte.js';
import './PurchaseResult.css.js';

/* src/ui/shared/components/PurchaseResult/PurchaseResult.svelte generated by Svelte v3.44.2 */

function create_if_block(ctx) {
	let div;
	let t_1_value = /*purchaseResult*/ ctx[0].title + "";
	let t_1;

	return {
		c() {
			div = element("div");
			t_1 = text(t_1_value);
			attr(div, "class", "purchase-result__name wcl-1vt5bm0");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t_1);
		},
		p(ctx, dirty) {
			if (dirty & /*purchaseResult*/ 1 && t_1_value !== (t_1_value = /*purchaseResult*/ ctx[0].title + "")) set_data(t_1, t_1_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (49:6) <Button on:click="{closePurchaseResult}">
function create_default_slot(ctx) {
	let t_1_value = t('Закрыть') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

function create_fragment(ctx) {
	let div4;
	let div3;
	let div0;
	let t1;
	let div1;
	let img;
	let img_src_value;
	let t2;
	let t3;
	let div2;
	let button;
	let div4_outro;
	let current;
	let mounted;
	let dispose;
	let if_block = /*purchaseResult*/ ctx[0].title && create_if_block(ctx);

	button = new Button({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*closePurchaseResult*/ ctx[2]);

	return {
		c() {
			div4 = element("div");
			div3 = element("div");
			div0 = element("div");
			div0.textContent = `${/*title*/ ctx[1]}`;
			t1 = space();
			div1 = element("div");
			img = element("img");
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			div2 = element("div");
			create_component(button.$$.fragment);
			attr(div0, "class", "purchase-result__title wcl-1vt5bm0");
			if (!src_url_equal(img.src, img_src_value = /*purchaseResult*/ ctx[0].productImageUrl)) attr(img, "src", img_src_value);
			attr(img, "alt", /*title*/ ctx[1]);
			attr(img, "class", "wcl-1vt5bm0");
			toggle_class(img, "failed", !/*purchaseResult*/ ctx[0].isSuccess);
			attr(div1, "class", "purchase-result__image wcl-1vt5bm0");
			attr(div2, "class", "purchase-result__button wcl-1vt5bm0");
			attr(div3, "class", "purchase-result wcl-1vt5bm0");
			toggle_class(div3, "success", /*purchaseResult*/ ctx[0].isSuccess);
			attr(div4, "class", "purchase-result-overlay wcl-1vt5bm0");
		},
		m(target, anchor) {
			insert(target, div4, anchor);
			append(div4, div3);
			append(div3, div0);
			append(div3, t1);
			append(div3, div1);
			append(div1, img);
			append(div3, t2);
			if (if_block) if_block.m(div3, null);
			append(div3, t3);
			append(div3, div2);
			mount_component(button, div2, null);
			current = true;

			if (!mounted) {
				dispose = listen(window, "keydown", /*handleKeydown*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*purchaseResult*/ 1 && !src_url_equal(img.src, img_src_value = /*purchaseResult*/ ctx[0].productImageUrl)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*purchaseResult*/ 1) {
				toggle_class(img, "failed", !/*purchaseResult*/ ctx[0].isSuccess);
			}

			if (/*purchaseResult*/ ctx[0].title) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div3, t3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			const button_changes = {};

			if (dirty & /*$$scope*/ 32) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);

			if (dirty & /*purchaseResult*/ 1) {
				toggle_class(div3, "success", /*purchaseResult*/ ctx[0].isSuccess);
			}
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			if (div4_outro) div4_outro.end(1);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			div4_outro = create_out_transition(div4, fade, { duration: 150 });
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div4);
			if (if_block) if_block.d();
			destroy_component(button);
			if (detaching && div4_outro) div4_outro.end();
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { purchaseResult } = $$props;
	const dispatch = createEventDispatcher();

	const title = purchaseResult.isSuccess
	? t('Покупка прошла успешно!')
	: t('Произошла ошибка. Повторите попытку позже.');

	onMount(() => {
		if (purchaseResult.isSuccess && isIngame()) {
			playExchangeSound();
		}
	});

	function closePurchaseResult() {
		disableBodyOverflow(false);
		updateBrowserControlState(false);
		dispatch('close');
	}

	function handleKeydown(e) {
		if (e.key === 'Escape') {
			closePurchaseResult();
		}
	}

	disableBodyOverflow(true);
	updateBrowserControlState(true);

	$$self.$$set = $$props => {
		if ('purchaseResult' in $$props) $$invalidate(0, purchaseResult = $$props.purchaseResult);
	};

	return [purchaseResult, title, closePurchaseResult, handleKeydown];
}

class PurchaseResult extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { purchaseResult: 0 });
	}
}

export { PurchaseResult as default };
//# sourceMappingURL=PurchaseResult.svelte.js.map
